export default __webpack_public_path__ + "static/media/81-4985512.433852ad.png";